import { ClearRounded, EditRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { action, API, controller } from "api";
import { AppContext } from "App";
import { Button } from "controls";
import { Alert, Dialog, Table } from "layout";
import { useContext, useEffect, useState } from "react";
import AddEditInqSrc from "./AddEditInqSrc";
import { formatDate } from "hooks";

const InquerySources = () => {
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const { setLoader, access } = useContext(AppContext);
  const [types, setTypes] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this source type?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res?.msg,
            });
            setTypes((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else if (res) {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res?.msg,
            });
          }
        };
        API(controller.InqSrc).Delete(id, onComplete);
      },
    });
  };

  useEffect(() => {
    setLoader(true);
    API(controller.InqSrc + action.GetAllByOrg).get((res) => {
      res.status === 200 && setTypes([...res.result]);
      setLoader(false);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ActionComp = (val) => (
    <div className="bs-secondary br-8 w-fit">
      {access?.inquerySource?.edit && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(val)}
            size="small"
            color="primary"
            className="mr-5 p-5"
          >
            <EditRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
      {access?.inquerySource?.delete && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(val.id)}
            size="small"
            color="error"
            className="mr-5 p-5"
          >
            <ClearRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>Add Inquiry Source</Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: "Name" },
          { id: "userName", label: "Added User" },
          { id: "addDate", label: "Create Date" },
          { id: "updDate", label: "Last Update Date" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={types.map((j) => ({
          ...j,
          userName: j.user?.fullName,
          addDate: formatDate(j.createDate),
          updDate: formatDate(j.updateDate),
        }))}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="xs">
          <AddEditInqSrc
            {...{ setShowForm: setShowForm, updData, setTypes, setAlert }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default InquerySources;
